import { ReactNode } from 'react';

import { Card } from '@sternum/web/components';

import { Description } from './Description';
import descriptionDecorationImgPath from './descriptionDecorationImg.svg';
import { Header } from './Header';

import {
  CardContent,
  CardWrapper,
  Container,
  ContentInnerWrapper,
  ContentWrapper,
  DecorationImgBig,
  DecorationImgBigWrapper,
  DecorationImgSmall,
  DescriptionWrapper,
} from './AuthContainer.styles';

interface AuthContainerComponentProps {
  children: ReactNode;
}

export function AuthContainer({ children }: AuthContainerComponentProps) {
  return (
    <Container>
      <Header />
      <ContentWrapper>
        <ContentInnerWrapper>
          <DescriptionWrapper>
            <Description />

            <DecorationImgSmall src={descriptionDecorationImgPath} alt="decoration" />
          </DescriptionWrapper>

          <CardWrapper>
            <Card flex={1} borderRadius={8} p={40}>
              <CardContent>{children}</CardContent>
            </Card>
          </CardWrapper>
        </ContentInnerWrapper>

        <DecorationImgBigWrapper>
          <DecorationImgBig src={descriptionDecorationImgPath} alt="decoration" />
        </DecorationImgBigWrapper>
      </ContentWrapper>
    </Container>
  );
}
